import { render } from "./shift-header.vue?vue&type=template&id=67cfe200"
import script from "./shift-header.vue?vue&type=script&lang=js"
export * from "./shift-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__